<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
  <nf-grid-wrapper-content>
    <span *nfLoader="accountSummaryLoading">
      <nf-table-layout
        class="accountSummary"
        hideTitle
        [data]="accountSummaryRowData"
        [gridOptions]="gridOptionsaccountSummary"
        [isSectionTitle]="true"
        hideClearAll
        hideSearch
      ></nf-table-layout>
    </span>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
